import {FindAvailabilityStepProps} from "../types";
import React, {FC} from "react";
import {Divider, TextField, Typography} from "@material-ui/core";
import {OrderEngineStepActions} from "./OrderEngineStepActions";

interface PersonalMessageStepProps extends FindAvailabilityStepProps<string> {
    workerName: string;
}

export const PersonalMessageStep: FC<PersonalMessageStepProps> = ({initialValue, onNext, onBack, workerName}) => {

    const [message, setMessage] = React.useState(initialValue ?? "");

    return (
        <React.Fragment>
            <Typography color={"textSecondary"} style={{marginTop: 16}}>
                Schreiben Sie eine Nachricht an den Gartenarbeiter
            </Typography>
            <Divider style={{marginBottom: 16, marginTop: 8}}/>
            <Typography variant="h6" color="secondary" style={{marginBottom: 16}}>
                Möchten Sie {workerName} noch etwas mitteilen?
            </Typography>
            <TextField
                label={"Persönliche Mitteilung"}
                value={message}
                fullWidth
                focused={true}
                placeholder={"Bitte 3x Klingeln\nIch bin dann hinten im Garten\nBitte vor dem Hund in Acht nehmen"}
                multiline
                rows={5}
                onChange={(e) => setMessage(e.target.value)}
            />
            <OrderEngineStepActions
                onClickNext={() => onNext(message)}
                onClickBack={onBack}
                lastStep={false}
            />
        </React.Fragment>
    );
}